import { type IntlShape, useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';

import type { goalTypeName$key } from './__generated__/goalTypeName.graphql';
import { isNameMessageId, messages } from './messages';

interface Params {
	messageId: string | null;
	defaultValue?: string | null;
	intl: IntlShape;
}

export const getGoalTypeNameIntl = ({
	messageId,
	defaultValue,
	intl,
}: Params): string | undefined => {
	return isNameMessageId(messageId)
		? intl.formatMessage(messages[messageId])
		: (defaultValue ?? undefined);
};

export const useGoalTypeName = (
	fragmentRef: goalTypeName$key | null | undefined,
): string | undefined => {
	const intl = useIntl();

	// eslint-disable-next-line @atlassian/data/no-wrapping-hooks
	const goalType = useFragment<goalTypeName$key>(
		graphql`
			fragment goalTypeName on GoalType {
				name {
					... on GoalTypeCustomName {
						value
					}
					... on LocalizationField {
						messageId
						defaultValue
					}
				}
			}
		`,
		fragmentRef,
	);

	if (!goalType?.name) {
		return undefined;
	}

	if (goalType.name.value) {
		return goalType.name.value;
	}

	const messageId = goalType.name.messageId ?? null;

	return getGoalTypeNameIntl({ messageId, defaultValue: goalType.name.defaultValue, intl });
};
